export const productFilterConfigPerType = {
    barcode: {
        default: {
            filterName: 'barcodeFilters',
            filterType: 'barcode',
            anonymizationPattern: 'EAN {level} - *******',
            labelKey: 'filterPopin.ean'
        },
        competitorBase: {
            filterName: 'competitorBaseBarcodeFilters',
            filterType: 'competitorBaseBarcode',
            anonymizationPattern: 'EAN {level} - *******',
            labelKey: 'filterPopin.ean'
        },
        competitorComparison: {
            filterName: 'competitorComparisonBarcodeFilters',
            filterType: 'competitorComparisonBarcode',
            anonymizationPattern: 'EAN {level} - *******',
            labelKey: 'filterPopin.ean'
        }
    },
    item: {
        default: {
            filterName: 'itemFilters',
            filterType: 'item',
            anonymizationPattern: 'Item {level} - *******',
            labelKey: 'filterPopin.item'
        },
        competitorBase: {
            filterName: 'competitorBaseItemFilters',
            filterType: 'competitorBaseItem',
            anonymizationPattern: 'Item {level} - *******',
            labelKey: 'filterPopin.item'
        },
        competitorComparison: {
            filterName: 'competitorComparisonItemFilters',
            filterType: 'competitorComparisonItem',
            anonymizationPattern: 'Item {level} - *******',
            labelKey: 'filterPopin.item'
        }
    }
};
//# sourceMappingURL=productFilterConfigPerType.constant.js.map